import { CsvExportParams } from 'ag-grid-enterprise';
import * as _ from 'lodash';
import moment from 'moment';

const SKIP_COLUMNS = ['select', 'cellAction', 'Image'];

const charsMap: any = { ' ': '', '&': 'And' };

interface IGridExportParams {
  fileName: string,
  colDefs: any[],
  allColumns?: boolean,
  isExportTemplate?: boolean,
  columnKeys?: any[],
  onlySelected?: boolean,
  specialCharactersFields?: any[],
}

export const getFilterModel = (gridFilters: any) => {
  const filterFields = _.keys(gridFilters);
  const filterModel: any = [];
  filterFields.forEach(field => {
    filterModel.push({
      field: field,
      filterType: gridFilters[field].filterType,
      type: gridFilters[field].type || gridFilters[field].filterType,
      filter: gridFilters[field].filter,
      filterValues: gridFilters[field].values,
      ...gridFilters[field].dateFrom && { dateFrom: gridFilters[field].dateFrom }
    });
  });
  return filterModel;
}

export const getSortModel = (gridSorting: any) => {
  const sortModel: any = [];
  gridSorting.forEach((field: any) => {
    if (field.sort) {
      sortModel.push({
        field: field.colId,
        order: field.sort
      });
    }
  });
  return sortModel;
}

export const getColumnKeys = (colDefs: any) => {
  const columnKeys: any = [];
  colDefs.forEach((col: any) => {
    if (col.children) {
      col.field && columnKeys.push(col.field);
      columnKeys.push(...(_.map(col.children, a => a.field)))
    } else if (col.field !== 'cellAction' && col.field !== 'select') {
      columnKeys.push(col.field);
    }
  });
  return columnKeys;
}

export const gridDataExportParams = (exportGridParams: IGridExportParams) => {
  const csvExportParams: CsvExportParams | any = {
    fileName: exportGridParams.fileName,
    allColumns: exportGridParams.allColumns || false,
    skipGroups: true,
    columnGroups: true,
    onlySelected: exportGridParams.onlySelected || false,
    columnKeys: exportGridParams.allColumns ? [] : _.differenceWith(exportGridParams.columnKeys, SKIP_COLUMNS, _.isEqual),
    processCellCallback: (params: any) => {
      if (params.column.getColDef().type === 'date') {
        return `${params.value ? (new Date(params.value)).toLocaleDateString() : ''}`;
      }
      if (params.column.getColDef().type === 'datetime') {
        return `${params.value ? moment.utc(params.value).local().format('MM/DD/YYYY hh:mm:ss A') : ''}`;
      }
      if (params.column.getColDef().field === 'upc' || params.column.getColDef().field === 'UPC') {
        return `="${params.value}"`;
      }
      if (exportGridParams.specialCharactersFields && exportGridParams.specialCharactersFields.includes(params.column.getColDef().field)) {
        return `${_.unescape(params.value)}`;
      }
      return params.value;
    },
    processHeaderCallback: (params: any) => {
      return exportGridParams.isExportTemplate ? _.get(params, 'column.colDef.headerName', '').replace(/[\s\&]/g, (m: any) => charsMap[m]) : _.get(params, 'column.colDef.headerName', '');
    }
  };
  return csvExportParams;
}


export const getDatePicker = () => {
  function Datepicker() {}
  Datepicker.prototype.init = function (params: any) {
    this.eInput = document.createElement('input');
    this.eInput.value = params.value && moment(params.value).format('YYYY-MM-DD');
    this.eInput.type = 'date';
    this.eInput.classList.add('ag-input');
    this.eInput.style.height = '100%';
  };
  Datepicker.prototype.getGui = function () {
    return this.eInput;
  };
  Datepicker.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
  };
  Datepicker.prototype.getValue = function () {
    return this.eInput.value;
  };
  Datepicker.prototype.destroy = function () {};
  Datepicker.prototype.isPopup = function () {
    return false;
  };
  return Datepicker;
}
